import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

const InnerPage = ({courses}, onDelete) => {
  if (!Array.isArray(courses) || courses.length === 0) {
    return <p>No courses available</p>; // Handle cases where courses is not an array
  }
  return (
    <>
      <div className="row">
        {courses.map((course) => (
          <div key={course._id} className="col-lg-12 col-md-12 d-flex">
            <div className="course-box course-design list-course d-flex">
              <div className="product">
                <div className="product-img">
                  <img
                    className="img-fluid"
                    alt={course.title}
                    src={`/${course.image}`} // Assuming the backend serves images
                  />
                  <div className="price">
                    <h3>${course.price}</h3>
                  </div>
                </div>
                <div className="product-content">
                  <div className="head-course-title">
                    <h3 className="title">{course.title}</h3>
                    <div className="all-btn all-category d-flex align-items-center">
                      <Link
                        to={`/edit-course/${course._id}`}
                        className="btn btn-primary me-2"
                      >
                        Edit
                      </Link>
                      <button
                        className="btn btn-danger"
                        onClick={() => onDelete(course._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                  <div className="course-info border-bottom-0 pb-0 d-flex align-items-center">
                    <p>{course.description}</p>
                  </div>
                  <div className="video-list">
                  <h4>Videos:</h4>
                  <ul>
                    {course.video && course.video.length > 0 ? (
                      course.video.map((vid) => (
                        <li key={vid.id}>
                          <a href={vid.videoURL} target="_blank" rel="noopener noreferrer">
                            {vid.videoURL || 'No URL provided'}
                          </a>
                        </li>
                      ))
                    ) : (
                      <p>No videos available</p>
                    )}
                  </ul>
                </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

InnerPage.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
      video: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          videoURL: PropTypes.string,
        })
      ),
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default InnerPage;
